<template>
	<div>
		<RadioGroup
			v-model="type"
			:options="typeOptions"
			@input="emitChangeEvent"
		/>
		<DatePickerCalendar
			v-if="dateEligible"
			v-model="date"
			:force-min-date="new Date()"
			:years-in-future="2"
			@input="emitChangeEvent"
		/>
	</div>
</template>

<script>
import DatePickerCalendar from "@/vue/common/form/DatePickerCalendar";
import {isDefined} from "@/helper/Value";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import {isEmptyOrNull} from "@/helper/String";

const TYPE__IMMEDIATELY = 'immediately';
const TYPE__DATE = 'date';

export default {

	components: {
		RadioGroup,
		DatePickerCalendar,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			type: this.value?.type,
			date: this.value?.date,
		};
	},

	computed: {
		typeOptions ()
		{
			return [
				{value: TYPE__IMMEDIATELY, text: 'Ab sofort'},
				{value: TYPE__DATE, text: 'Ab bestimmten Datum'},
			];
		},
		dateEligible ()
		{
			return this.type === TYPE__DATE;
		},
		dateValid ()
		{
			return !this.dateEligible || isDefined(this.date);
		},
		dataValid ()
		{
			return !isEmptyOrNull(this.type) && this.dateValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);

				return;
			}

			this.$emit('input', {
				type: this.type,
				date: this.dateEligible
					? this.date
					: undefined
			});
		}
	}
}
</script>
